"use client";

import { useCallback } from "react";
import { useLocale } from "next-intl";

import type { GeoTemplate, GeoTemplateProps } from "./GeoBlockSlot";

import { useGeoOverride } from "@utilities/geo/useGeoOverride";

import { GeoRegistry } from "./GeoRegistry";

export type GeoBlockWrapperProps = {
  blockType: GeoTemplate;
  defaultProps: GeoTemplateProps | undefined;
  overrideCountries: string[];
  reusableBlockId: string;
  blockId: string;
};

export function GeoBlockWrapper({
  blockType,
  defaultProps,
  overrideCountries,
  reusableBlockId,
  blockId,
}: GeoBlockWrapperProps) {
  const locale = useLocale();

  const fetchOverride = useCallback(async (): Promise<GeoTemplateProps | null> => {
    const params = new URLSearchParams({
      rbId: reusableBlockId,
      blockId,
      template: blockType,
      locale,
    });
    const res = await fetch(`/next/api/geo-country?${params}`);
    const data: { props: GeoTemplateProps | null } = await res.json();
    return data.props;
  }, [reusableBlockId, blockId, blockType, locale]);

  const { resolved, needsOverride } = useGeoOverride<GeoTemplateProps | null>({
    overrideCountries,
    fetchOverride,
    fallback: defaultProps ?? null,
  });

  if (needsOverride === null || needsOverride === false || !resolved) {
    return null;
  }

  return (
    <div data-geo-resolved>
      <GeoRegistry blockType={blockType} resolvedProps={resolved} defaultProps={defaultProps} />
    </div>
  );
}
